import Vue from 'vue';
import Router from 'vue-router';


// import Login from './views/Login.vue';  // 慧简学V1.3需求：慧简学租户用管理后台新界面
/* eslint-disable */

window.getQueryString2 = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return decodeURIComponent(pair[1]);}
  }
  return(false);
}
// 获取hash路由参数
// window.getHashParameter = (key)=> {
//   var arr = (window.location.hash || '').split('?')[1].split('&')
//   var params = {}
//   for (var i = 0; i < arr.length; i++) {
//     var data = arr[i].split('=')
//     if (data.length === 2) {
//       params[data[0]] = data[1]
//     }
//   }
//   return params[key]
// }
window.getHashParameter = (key)=> {
  try{
    var arr = (window.location.hash || '').split('?')[1].split('&')
    var params = {}
    for (var i = 0; i < arr.length; i++) {
      var data = arr[i].split('=')
      if (data.length === 2) {
        params[data[0]] = data[1]
      }
    }
    return params[key]
  } catch(e) {}
  return ''
}
window.isSaas = false
window.getHostName = window.getQueryString2('hostname') || window.getHashParameter('hostname')
/* 
  关于域名的3个情况
  1.当前地址是旧的域名，没有独立域名，在旧的域名登录
  2.当前地址是旧的域名，已经有独立域名，跳去引导页
  3.当前地址是旧的域名，且拉入黑名单了，跳去404
*/
// 带id参数判断为公用域名——旧域名
if (window.getHostName || location.hostname === 'sys.myunedu.com') {
  window.isDomain = false//当前是旧域名
  window.isSaas = true//是否为招服机构用的登录页面标识
  if (location.pathname.indexOf('/id/') !== -1) {
    window.rentId = location.pathname.split('/id/')[1]
    window.rentId = window.rentId.replace('/','')
  } else {
    window.rentId = window.getQueryString2('id')
  }
}else{
  // 不带id参数判断为独立域名
  //过滤白名单
  let arr = [
    // 测试登录地址
    'aline.mshengedu.com',
    'mline.mshengedu.com',
    'pline.mshengedu.com',
    'grey.mshengedu.com',
    'grey.mshiedu.com',
    // 线上登录地址
    'sys.myunedu.com',
    'login.mshiedu.com',
    'login.mshengedu.com',
  ]
  if(!arr.includes(window.location.hostname)){
    // 当前是独立域名
    window.isDomain = true
    window.isSaas = true
  }
}
console.log('window.rentId',window.rentId)
if (window.isSaas) {
  document.title = '后台管理系统'
} else {
  document.title = '帕莱托登录入口'
}
if(window.top == window.self) {
  console.log('不存在父页面') // 自营情况
} else {
  try{
    if(window.parent.adminUrl){//独立域名
      window.parent.location.href = window.parent.adminUrl
    }
    if (window.parent.location.hostname.indexOf('sys.myunedu.com') !== -1) { // 在menu工程页面里面 检测到里面内嵌推出情况
      window.parent.location.href = (`${process.env.NODE_ENV}` === 'production' ? `https://sys.myunedu.com` : `${process.env.VUE_APP_LOCALTION_URL}`) +`?hostname=hjxs2b&id=${localStorage.getItem('ALLrentId')}`
      console.log('存在父页面')
    }
  }catch(e){}
  
}
try {
  if(window.isSaas){
    window.favicon = document.createElement("link");
    window.favicon.rel = "icon";
    window.favicon.id = "favicon_icon";
    window.favicon.href = 'https://file.mshiedu.com/%E6%85%A7%E7%AE%80%E5%AD%A6-logo.png';
    document.head.appendChild(favicon);
  }else {
    window.favicon = document.createElement("link");
    window.favicon.rel = "icon";
    window.favicon.id = "favicon_icon";
    window.favicon.href = 'https://file.mshiedu.com/palaituo-logo.png';
    document.head.appendChild(favicon);
  }
} catch(e) {}



Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: (resolve) => {window.isSaas?require(['@/views/HjxLogin.vue'], resolve):require(['@/views/Login.vue'], resolve)},
    },
    {
      path: '/login',
      name: 'login',
      component: (resolve) => {window.isSaas?require(['@/views/HjxLogin.vue'], resolve):require(['@/views/Login.vue'], resolve)},
    },
    {
      path: '/forgetPass',
      name: 'forgetPass',
      component: (resolve) => require(['@/views/forgetPass.vue'], resolve),
    },
    {
      path: '/bindPhone',
      name: 'bindPhone',
      component: (resolve) => require(['@/views/bindPhone.vue'], resolve),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/small/login',
      name: 'login',
      component: (resolve) => {window.isSaas?require(['@/views/HjxLogin.vue'], resolve):require(['@/views/Login.vue'], resolve)},
    }
  ],
});
